<template>
  <div class="page">
    <div :class="`page-contain ${isWeixin ? 'page-wx' : 'page-nowx'}`">
      <div class="page-body">
        <div>
          <!--v-if="qrcodeList[1]"-->
          <template>
            <div v-if="qrcodeList[1]" class="qrcode-block write-block">
              <div class="titleWrp">*请勿中途退出页面，防止页面丢失</div>
              <div class="txtWrp">写字老师</div>
              <vue-qr
                class="qrcode-pic"
                :text="qrcodeList[1]"
                :margin="0"
                :size="90"
                :dot-scale="1"
              />
            </div>
            <div class="flexWrp">
              <div v-if="qrcodeList[3]" class="qrcode-block other-block">
                <div class="txtWrp">软笔老师</div>
                <vue-qr
                  class="qrcode-pic"
                  :text="qrcodeList[3]"
                  :margin="0"
                  :size="90"
                  :dot-scale="1"
                />
              </div>
              <div v-if="qrcodeList[2]" class="qrcode-block other-block">
                <div class="txtWrp">美术老师</div>
                <vue-qr
                  class="qrcode-pic"
                  :text="qrcodeList[2]"
                  :margin="0"
                  :size="90"
                  :dot-scale="1"
                />
              </div>
              <div v-if="qrcodeList[12]" class="qrcode-block other-block">
                <div class="txtWrp">双语美术老师</div>
                <vue-qr
                  class="qrcode-pic"
                  :text="qrcodeList[12]"
                  :margin="0"
                  :size="90"
                  :dot-scale="1"
                />
              </div>
              <div v-if="qrcodeList[14]" class="qrcode-block other-block">
                <div class="txtWrp">观鱼书画</div>
                <vue-qr
                  class="qrcode-pic"
                  :text="qrcodeList[14]"
                  :margin="0"
                  :size="90"
                  :dot-scale="1"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductApi from 'api/ProductApi';
import { getWebEnv } from 'assets/tools.js';
import vueQr from 'vue-qr';

export default {
  components: {
    vueQr
  },
  data () {
    return {
      qrcodeList: {},
      isWeixin: true
    };
  },
  computed: {
    mySwiperList () {
      return Object.keys(this.qrcodeList).map(item => {
        let title = '其他老师';
        switch (item) {
          case '1':
            title = '河小象写字';
            break;
          case '2':
            title = '河小象美术';
            break;
          case '3':
            title = '河小象软笔';
            break;
          case '14':
            title = '观鱼书画';
            break;
        }
        return {
          title,
          qrcode: this.qrcodeList[item]
        };
      });
    }
  },
  created () {
    this.getQrcode();
    this.isWeixin = getWebEnv().isWeixin;
  },
  methods: {
    getQrcode () {
      ProductApi.getQrcodeList({
        series_number: this.$route.query.productId
      }).then(res => {
        this.qrcodeList = res.data;
      });
    }
  }
};

</script>
<style lang="scss" scoped>

.page{
background-color: #FFF3DA;
    min-height: 100vh;
}
.page-contain {
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 7.17rem 0.64rem 0;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  .page-top {
    display: flex;
    .top-left {
      margin: 5px 0 4px;
      position: relative;
      .top-left-pic {
        width: 20px;
        height: 102px;
      }
      .top-left-line {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -55%);
        border-radius: 3px;
        width: 3px;
        height: 50px;
        background: rgba(62, 145, 251, 1);
      }
    }
    .top-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 16px;
      line-height: 30px;
      font-size: 19px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(68, 68, 68, 1);
    }
  }
  .page-body {
    .body-tip {
      margin-bottom: 13px;
      line-height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(183, 183, 183, 1);
    }
    .titleWrp {
      width: 100%;
      font-size: 0.32rem;
      color: #fbb102;
      text-align: center;
      background-color: #fff9da;
      line-height: 0.8rem;
      border-radius: 16px 16px 0 0;
    }

    .write-block {
      background: white;
      color: #89483d;
      .qrcode-pic {
        width: 5.25rem;
        height: 5.25rem;
      }
    }
  }
}
.other-block {
  width: 4.18rem;
  background: white;
  color: #89483d;
}
.qrcode-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.34rem;
  box-sizing: border-box;
  border-radius: 16px;
  font-size: 20px;
  flex-direction: column;
  box-shadow: 0 0 20px 0 rgba(248, 222, 172, 0.81);
  .qrcode-pic {
    width: 2.9rem;
    height: 2.9rem;
    margin: 0.32rem 0 0.32rem 0;
  }
}
.flexWrp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flexWrp .qrcode-block:nth-child(odd) {
  margin-right: 0.17rem;
}
.flexWrp .qrcode-block:nth-child(even) {
  margin-left: 0.17rem;
}
.page-wx {
  background-image: url(../assets/sucWxBg.png);
}
.page-nowx {
  background-image: url(../assets/sucNowxBg.png);
}
.txtWrp {
  margin-top: 0.32rem;
  font-family: Tensentype-JiaLiDaYuanJ;
  font-size: 20px;
  color: #89483d;
}
</style>
